module.exports = __webpack_public_path__ + "img/9788958282181.ee4d04e4.jpg";